<template>
  <div class="seomain">
    <ul class="tab-tilte">
      <li
        v-for="(title, index) in tabTitle"
        @click="
          changeActiveIndex(index);
          get_st_list(index);
        "
        :class="{ active: cur == index }"
        class="text-center"
        :key="index"
      >
        <span>{{ title }}</span>
      </li>
      <div class="cl"></div>
    </ul>
    <!-- 搜索  单行 -->
    <!-- <div class="keyword">
      <van-search
        v-model="order_code"
        shape="round"
        show-action
        background="#e0e0e0"
        placeholder="请输入订单号搜索"
        @search="onSearch"
        @cancel="onCancel"
      />
    </div> -->

    <!-- 搜索 多行 -->
    <div class="keyword">
      <van-form @submit="submitKeyword">
        <van-field v-model="order_code" label="单号" placeholder="请输入单号" />
        <van-field v-model="sku" label="SKU" placeholder="SKU" />
        <div :style="{ padding: '16px', backgroundColor: '#fff' }">
          <van-button round block type="info" native-type="submit">搜 索</van-button>
        </div>
      </van-form>
    </div>
    <div class="tab-content tab-content-list">
      <div v-show="cur == 0" class="st-list-box pan-0">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist0" :key="k" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">采购在途</div>
            </div>
            <div class="st-list-main">
              <p>采购类型：{{ v.style }}</p>
              <p v-if="v.scrapped_order_code">下架工单号：{{ v.scrapped_order_code }}</p>
              <p>采购数量：{{ v.totalnum }}</p>
              <p>供应商：{{ v.suppliername }}</p>
              <p>物流方：{{ v.purchasingtracking }}</p>
              <p @click="getExInfo(v.id)">物流单号：{{ v.shipmentnumber }}</p>
              <p>采购人：{{ v.operatorname }}</p>
              <p>预计到货时间：{{ v.deliverytime }}</p>
              <div v-if="v.inspect == 0" class="inspectBtn" @click="showCheckDialogHandle(v.id, v.inspect)">未质检</div>
              <div v-if="v.inspect == 1" class="inspectBtn checkBy" @click="showCheckDialogHandle(v.id, v.inspect)">
                合格
              </div>
              <div v-if="v.inspect == 2" class="inspectBtn " @click="showCheckDialogHandle(v.id, v.inspect)">
                不合格
              </div>
              <div v-if="v.inspect == 3" class="inspectBtn checkBy" @click="showCheckDialogHandle(v.id, v.inspect)">
                特许入库
              </div>
            </div>

            <div class="st-list-bottom-diy">
              <div class="st-diyl-btn">
                <router-link :to="'/purchase/receive/' + v.id" class="st-opt-btn">签 收</router-link>
              </div>
              <div class="st-diyr-btn">
                <div class="st-opt-btn" @click="goUrl(v.inspect, '/purchase/info/' + v.id)">
                  入 库
                </div>
                <!-- <router-link :to="'/purchase/info/' + v.id" class="st-opt-btn">入 库</router-link> -->
              </div>
            </div>
          </div>
        </van-list>
      </div>
      <div v-show="cur == 1" class="st-list-box pan-1">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist1" :key="k" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">部分已入库</div>
            </div>
            <div class="st-list-main">
              <p>采购类型：{{ v.style }}</p>
              <p v-if="v.scrapped_order_code">下架工单号：{{ v.scrapped_order_code }}</p>
              <p>采购数量：{{ v.totalnum }}</p>
              <p>供应商：{{ v.suppliername }}</p>
              <p class="red bold">待入库：{{ v.total_storageing }}</p>
              <p>物流方：{{ v.purchasingtracking }}</p>
              <p @click="getExInfo(v.id)">物流单号：{{ v.shipmentnumber }}</p>
              <p>采购人：{{ v.operatorname }}</p>
              <div v-if="v.inspect == 0" class="inspectBtn" @click="showCheckDialogHandle(v.id, v.inspect)">未质检</div>
              <div v-if="v.inspect == 1" class="inspectBtn checkBy" @click="showCheckDialogHandle(v.id, v.inspect)">
                合格
              </div>
              <div v-if="v.inspect == 2" class="inspectBtn " @click="showCheckDialogHandle(v.id, v.inspect)">
                不合格
              </div>
              <div v-if="v.inspect == 3" class="inspectBtn checkBy" @click="showCheckDialogHandle(v.id, v.inspect)">
                特许入库
              </div>
            </div>

            <div class="st-list-bottom-diy">
              <div class="st-diyl-btn">
                <router-link :to="'/purchase/receive/' + v.id" class="st-opt-btn">签 收</router-link>
              </div>
              <div class="st-diyr-btn">
                <div class="st-opt-btn" @click="goUrl(v.inspect, '/purchase/info/' + v.id)">
                  入 库
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
      <div v-show="cur == 2" class="st-list-box pan-2">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist2" :key="k" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">已入库</div>
            </div>
            <div class="st-list-main">
              <p>采购类型：{{ v.style }}</p>
              <p v-if="v.scrapped_order_code">下架工单号：{{ v.scrapped_order_code }}</p>
              <p>采购数量：{{ v.totalnum }}</p>
              <p>供应商：{{ v.suppliername }}</p>
              <p>物流方：{{ v.purchasingtracking }}</p>
              <p @click="getExInfo(v.id)">物流单号：{{ v.shipmentnumber }}</p>
              <p>采购人：{{ v.operatorname }}</p>
            </div>
            <div class="st-list-bottom">
              <router-link :to="'/purchase/info/' + v.id + '/false'" class="st-opt-btn">查 看</router-link>
            </div>
          </div>
        </van-list>
      </div>
    </div>

    <van-dialog class="exDialog" v-model="exShow" :title="exDialogTitle">
      <van-steps direction="vertical" :active="0" active-color="#fa6e09">
        <van-step v-for="(item, index) in exDataList" :key="index">
          <h3>{{ item.time }}</h3>
          <p>{{ item.step }}</p>
        </van-step>
      </van-steps>
    </van-dialog>

    <!-- 质检对话框 -->
    <van-dialog
      class="checkDialog"
      v-model="checkShow"
      title="质检"
      showCancelButton
      @cancel="checkShow = false"
      @confirm="onCheckHandle"
    >
      <van-radio-group v-model="checkForm.inspect">
        <van-radio name="1">合格</van-radio>
        <van-radio name="2">不合格</van-radio>
        <van-radio name="3">特许入库</van-radio>
      </van-radio-group>
      <el-input
        type="textarea"
        :autosize="{ minRows: 2, maxRows: 4 }"
        placeholder="请输入特许入库原因"
        v-model="checkForm.msg"
        v-if="checkForm.inspect == 3"
      >
      </el-input>
    </van-dialog>

    <!-- 选择仓位 -->
    <van-popup v-model="cascaderShow" round position="bottom">
      <van-cascader
        v-model="cascaderValue"
        title="请选择仓库信息"
        :options="options"
        @close="cascaderShow = false"
        @finish="onFinish"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      cascaderShow: false,
      fieldValue: "",
      cascaderValue: "",
      options: [
        {
          text: "深圳旗丰仓",
          value: "1",
          children: [
            {
              text: "深圳旗丰仓",
              value: "0",
              children: [
                {
                  text: "仓位1",
                  value: "1",
                },
                {
                  text: "仓位2",
                  value: "2",
                },
              ],
            },
            {
              text: "子仓库A",
              value: "1",
              children: [
                {
                  text: "仓位3",
                  value: "3",
                },
                {
                  text: "仓位4",
                  value: "4",
                },
              ],
            },
            {
              text: "子仓库B",
              value: "1",
              children: [
                {
                  text: "仓位5",
                  value: "5",
                },
                {
                  text: "仓位6",
                  value: "6",
                },
              ],
            },
          ],
        },
      ],
      loading: false,
      finished: false,
      page: 1,
      tabTitle: ["待入库", "部分待入库", "已入库"],
      cur: 0,
      stlist0: [],
      stlist1: [],
      stlist2: [],
      exShow: false,
      exDataList: [],
      exDialogTitle: "",
      checkShow: false, // 质检对话框
      checkForm: {
        id: 0,
        inspect: 0,
        msg: "",
      },
      order_code: "", // 关键字搜索
      sku: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    async get_st_list(e) {
      this.stlist0 = [];
      this.stlist1 = [];
      this.stlist2 = [];
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.onLoad();
    },
    init() {
      let activeIndex = window.sessionStorage.getItem("purchase_activeIndex");
      if (activeIndex) {
        this.cur = activeIndex;
      }
    },
    changeActiveIndex(value) {
      this.cur = value;
      window.sessionStorage.setItem("purchase_activeIndex", value);
    },
    // 分页
    async onLoad() {
      let result = await this.$post(this.$api.stGetCaigouList, {
        order_code: this.order_code,
        status: this.cur,
        page: this.page,
        sku: this.sku,
      });

      if (result.data.length == 0) return (this.finished = true);
      // 进行操作
      this["stlist" + this.cur].push(...result.data.list);
      // 操作完成
      this.page += 1;
      this.loading = false;
    },
    goPurchaseInfo(flag, path) {
      console.log(flag, path);
      if (flag == 0) {
        this.$toast.fail("请先质检");
        return;
      }
      this.$router.push(path);
    },
    goUrl(flag, url) {
      if (flag == 0 || flag == 2) {
        this.$toast.fail("未质检或质检不合格");
        return;
      }
      this.$router.push(url);
    },
    // 获取物流信息
    async getExInfo(id) {
      let { purchasingtracking, shipmentnumber } = this["stlist" + this.cur].filter((item) => item.id == id)[0];
      this.exDialogTitle = purchasingtracking + ": " + shipmentnumber;

      let result = await this.$post(this.$api.stGetCaigouExInfo, { id });
      if (result.data.code == 1) {
        console.log(result.data.data);
        this.exDataList = result.data.data;
      } else {
        this.exDataList = [{ step: "暂无轨迹信息,请确认订单号是否填写正确." }];
      }
      this.exShow = true;
    },
    // 显示质检对话框的回调
    showCheckDialogHandle(id, inspect) {
      this.checkShow = true;
      this.checkForm = {
        id,
        inspect,
        msg: "",
      };
    },
    // 完成质检的回调
    async onCheckHandle() {
      let { id, inspect, msg } = this.checkForm;
      if (inspect == 0) return this.$toast.fail("质检结果不能为空");
      if (inspect == 3 && msg.trim() == "") return this.$toast.fail("请填写特许入库原因");
      let resutl = await this.$post(this.$api.stGetCaigouCheck, this.checkForm);
      this.$toast.success("修改成功");
      this["stlist" + this.cur] = this["stlist" + this.cur].filter((item) => {
        if (item.id == id) {
          item.inspect = inspect;
        }
        return item;
      });
    },

    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.cascaderShow = false;
      this.fieldValue = selectedOptions.map((option) => option.text).join("/");
    },

    onSearch(val) {
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
    onCancel() {},
    // 关键字搜索
    submitKeyword() {
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
  },
  created() {
    this.order_code = this.$route.params.orderId;
    this.init();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "采购入库" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.keyword {
  position: fixed;
  width: 100%;
  top: 50px;
}
/* 2行input start */
.tab-content-list {
  padding-top: 220px;
}
/* 2行input  end */

.st-list-bottom-diy {
  display: flex;
}
.st-list-bottom-diy .st-diyl-btn {
  background: #00baad;
  border-radius: 5px;
  flex: 1;
  margin-right: 8px;
}
.st-list-bottom-diy .st-diyl-btn.active {
  background: #677588;
}
.st-list-bottom-diy .st-diyr-btn {
  background: #3c8dbc;
  border-radius: 5px;
  flex: 1;
  margin-left: 8px;
}
.tab-tilte {
  z-index: 99;
}
.st-list-main {
  position: relative;
}
.st-list-main .inspectBtn {
  box-sizing: border-box;
  position: absolute;
  display: inline-block;
  top: 6px;
  right: 10px;
  padding: 0px 10px;
  line-height: 28px;
  text-align: center;
  border-radius: 14px;
  color: #fff;
  background-color: #677588;
}
.st-list-main .inspectBtn.checkBy {
  background-color: #00baad;
}

.checkDialog {
  padding: 10px 20px;
  .van-radio {
    margin: 10px 0;
  }
}
</style>
